import { ICouponsState } from '@/@types'

const state: ICouponsState = {
  couponStr: null,
  couponStrStack: null,
  couponObj: null,
  couponObjStack: null,
  couponLoading: false,
  couponTotalDiscount: null,
  couponTotalDiscountCents: null,
}

export default state
